import { trans } from "@mongez/localization";
import { useSubmitButton } from "@mongez/react-form";
import type { ComponentProps } from "react";
import { cn } from "~/shared/lib";
import { Button } from "./Button";

type SubmitButtonProps = ComponentProps<"button">;

export function SubmitButton({
  children,
  className,
  ...props
}: SubmitButtonProps) {
  const { isSubmitting, disabled } = useSubmitButton();

  return (
    <Button
      type="submit"
      {...props}
      disabled={isSubmitting || disabled}
      className={cn(
        "hover:bg-dirt-default w-full rounded-full bg-white px-8 py-4 font-bold text-black disabled:bg-gray-300 disabled:opacity-50 disabled:hover:text-black",
        className,
      )}
    >
      {isSubmitting ? `${trans("submitting")}...` : children || trans("submit")}
    </Button>
  );
}
